export default {
  en: {
    signinModal: {
      title: "Sign in to your account",
      emailLabel: "Email address",
      emailPlaceholder: "Enter your email",
      noAccountText: "Don't have an account?",
      signUpLink: "Sign up",
      passwordLabel: "Password",
      passwordPlaceholder: "Enter your password",
      resetPasswordLink: "Reset password",
      closeButton: "Close",
      signInButton: "Sign in",
    },
    signoutModal: {
      title: "Are you sure you want to sign out?",
      confirmText: "Confirm that you want to log out",
      cancelButton: "Cancel",
      signOutButton: "Sign out",
    },
    errorModal: {
      signInErrorTitle: "An error occurred during sign in",
      unknownError: "An unknown problem occurred",
      closeButton: "Close",
    },
    cookieModal: {
      title: "Cookie consent",
      description:
        "We use necessary cookies to make our site work. We'd like to set additional cookies to understand site usage, make site improvements and remember your settings. We also use cookies set by other sites to help deliver content from their services.",
      policyText: "To learn more, please read our",
      policyLink: "Privacy and Cookie Policy",
      customizeButton: "Customize my cookies",
      acceptButton: "Accept all cookies",
      rejectButton: "Reject optional cookies",
    },
  },
  de: {
    signinModal: {
      title: "Melden Sie sich bei Ihrem Konto an",
      emailLabel: "E-Mail-Adresse",
      emailPlaceholder: "Geben Sie Ihre E-Mail ein",
      noAccountText: "Haben Sie noch kein Konto?",
      signUpLink: "Registrieren",
      passwordLabel: "Passwort",
      passwordPlaceholder: "Geben Sie Ihr Passwort ein",
      resetPasswordLink: "Passwort zurücksetzen",
      closeButton: "Schließen",
      signInButton: "Anmelden",
    },
    signoutModal: {
      title: "Möchten Sie sich wirklich abmelden?",
      confirmText: "Bestätigen Sie, dass Sie sich abmelden möchten",
      cancelButton: "Abbrechen",
      signOutButton: "Abmelden",
    },
    errorModal: {
      signInErrorTitle: "Beim Anmelden ist ein Fehler aufgetreten",
      unknownError: "Ein unbekanntes Problem ist aufgetreten",
      closeButton: "Schließen",
    },
    cookieModal: {
      title: "Cookie-Einwilligung",
      description:
        "Wir verwenden notwendige Cookies, um unsere Website funktionsfähig zu machen. Wir möchten zusätzliche Cookies setzen, um die Nutzung der Website zu verstehen, Verbesserungen vorzunehmen und Ihre Einstellungen zu speichern. Wir verwenden auch Cookies von anderen Websites, um Inhalte von deren Diensten bereitzustellen.",
      policyText: "Weitere Informationen finden Sie in unserer",
      policyLink: "Datenschutz- und Cookie-Richtlinie",
      customizeButton: "Meine Cookies anpassen",
      acceptButton: "Alle Cookies akzeptieren",
      rejectButton: "Optionale Cookies ablehnen",
    },
  },
};
